module.exports = __webpack_public_path__ + "static/media/sf-trial-2.3272ca8d.mp3";